
import React from 'react';
import { Link } from 'react-router-dom';
import { Utensils } from 'lucide-react';
import MoreMenu from './navigation/MoreMenu';
import { useUser } from '@/contexts/UserContext';
import { useIsNewUser } from '@/hooks/useIsNewUser';
import { useModalContext } from '@/contexts/ModalProvider';
import { useIsMobile } from '@/hooks/use-mobile';

const UnifiedHeader: React.FC = React.memo(() => {
  const { isAuthenticated } = useUser();
  const { isNewUser } = useIsNewUser();
  const { isAnyModalOpen } = useModalContext();
  const isMobile = useIsMobile();
  
  // Don't show header on auth pages or if not authenticated
  if (!isAuthenticated) return null;

  // Hide on desktop for all authenticated users, show on mobile/tablet
  const shouldHideHeader = isMobile && isAnyModalOpen;
  const baseHeaderClassName = "bg-background/95 w-full py-4 px-4 fixed top-0 z-header lg:hidden border-b border-border/10 transition-opacity duration-300";
  const headerClassName = shouldHideHeader 
    ? `${baseHeaderClassName} opacity-0 pointer-events-none`
    : baseHeaderClassName;

  return (
    <>
      <header className={headerClassName}>
        <div className="flex items-center justify-between pt-2">
          <Link to="/" className="flex items-center gap-2 text-xl font-bold text-primary">
            <Utensils className="h-7 w-7 text-recipe" />
            <span className="font-playfair lowercase">forkast</span>
          </Link>
          
          <MoreMenu variant="mobile" />
        </div>
      </header>
    </>
  );
});

UnifiedHeader.displayName = 'UnifiedHeader';

export default UnifiedHeader;
